import { SET_SECOND_SCREEN, RESET_SECOND_SCREEN } from '../Types';

const initialState = {
  isDeviceActivation: false,
  code: '',
  device: '',
};

export const secondScreen = (state = initialState, action) => {
  switch (action.type) {
    case SET_SECOND_SCREEN:
      return { ...state, ...action.payload };
    case RESET_SECOND_SCREEN:
      return { ...state, ...initialState };
    default:
      return state;
  }
};
